module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAQAAADYWf5HAAAAW0lEQVQoz2NgoCm4w3Vnwh02wspK7/y6k01Ikdadx3f+37l9RxmfIsY7c4GKQHDiHUbcyhzvvIMq+3THBpci3jv7oIpAcMcdduzKEu/8vPMdDn/eiWQYBYMKAAC3ykIEuYQJUgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// /Users/vijay/projects/customers-app/node_modules/datatables.net-dt/images/sort_asc_disabled.png
// module id = ../../../../datatables.net-dt/images/sort_asc_disabled.png
// module chunks = styles